export default __webpack_public_path__ + "static/media/home-banner-latest.4d75cfd4.jpg";